import { errorReportActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
    submitting: false,
    lastErno: undefined
};

export const reducer = createReducer(initialState, {

    [errorReportActions.sendRequest]: (state, action) => {
        state.submitting = true;
    },
    [errorReportActions.sendSuccess]: (state, action) => {
        state.lastErno = action.payload.response;
        state.submitting = false;
    },
    [errorReportActions.sendFailure]: (state, action) => {
        state.submitting = false;
    },
})


